import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

const Result = () => {

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                <div className='col-span-12'>
                    <div className='relative w-full'>
                        <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Results</p>
                    </div>
                    <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                        <div className="grid grid-cols-12  flex-wrap">
                            <div className="col-span-12  lg:col-span-6 mt-[.5rem] relative w-full px-[6px]">
                                <div className="inline-flex relative align-middle" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="rounded-br-none rounded-tr-none flex-auto relative bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal hover:bg-[linear-gradient(#146578,_#5ecbdd)]  hover:border-[#72bbef]">Today</button>
                                    <button className="rounded-bl-none rounded-tl-none flex-auto relative bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal ml-1 hover:bg-[linear-gradient(#146578,_#5ecbdd)]  hover:border-[#72bbef]">Yesterday</button>
                                </div>
                            </div>
                            <div className="col-span-12  lg:col-span-6 mt-[.5rem] relative w-full px-[6px]">
                                <div className="text-[15px] relative !float-right">
                                    <select className="text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding bg-[#fff] border-[1px] border-[solid] border-[#ced4da] rounded-[.25rem] text-[#495057] block font-normal leading-normal w-full [word-wrap:normal]" name="eventType">
                                        <option value="4">Cricket</option>
                                        <option value="1">Soccer</option>
                                        <option value="2">Tennis</option>
                                        {/* <option value="7">Horse</option> */}
                                        {/* <option value="4339">Greyhound</option> */}
                                        {/* <option value="400">Kabaddi</option> */}
                                        {/* <option value="500">Election</option> */}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="p-[.5rem]">
                                <table className="!text-[#000] w-full whitespace-normal !mb-[.25rem]">
                                    <thead>
                                        <tr className="!bg-[#028dad] !text-[#fff]">
                                            <th className="text-[13px] leading-[16px] !p-[8px]  border-b-[2px_solid_#dee2e6] align-bottom border-[1px] border-[solid] border-[#dee2e6]">Date</th>
                                            <th className="text-[13px] leading-[16px] !p-[8px]  border-b-[2px_solid_#dee2e6] align-bottom border-[1px] border-[solid] border-[#dee2e6]">Event Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]"></td>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">
                                                <span className=' text-[#1288a0] underline cursor-pointer  '></span>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">18/02/2025 04:22</td>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">
                                                <span className=' text-[#1288a0] underline cursor-pointer  '>Ranji Trophy Elite 2024-25-Gujarat v Kerala [17/02/2025 04:00]</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">18/02/2025 04:22</td>
                                            <td className="text-[13px] leading-[16px] !p-[8px] border-[1px] border-[solid] border-[#dee2e6]">
                                                <span className=' text-[#1288a0] underline cursor-pointer  '>Ranji Trophy Elite 2024-25-Gujarat v Kerala [17/02/2025 04:00]</span>
                                            </td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div >

            </div >
        </div >
    )
}
export default Result